/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconTrident: {
  name: 'trident';
  data: string;
} = {
  name: 'trident',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M553.036 552.411 488.657 402.129 459.996 430.79 297.728 268.522 355.64 210.61 468.854 323.823 440.907 351.77 591.19 416.148 526.811 265.866 497.47 295.207 369.948 167.686 356.322 154.06 342.014 168.368 280.508 229.873 70.291 19.656 20.525 19.656 20.522 19.654 20.522 69.423 230.435 279.947 168.959 341.423 154.651 355.731 168.277 369.357 295.799 496.878 266.49 526.187 416.773 590.565 352.394 440.283 324.414 468.263 211.2 355.05 269.112 297.138 431.38 459.406 402.753 488.033z"/></svg>`,
};
